import React, { useCallback, useEffect, useState } from "react";
import { FaUtensils, FaGlassMartiniAlt } from "react-icons/fa";
import { MdDiscount } from "react-icons/md";
import "./PartywittyCheckout.css";
import logo from "../Assets/logo.svg";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { API_BASE_URL } from "../utils";
import axios from "axios";
import iziToast from 'izitoast';






const PartywittyCheckout = () => {
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    const [processing, setProcessing] = useState(false); // ✅ Added

    const [price, setPrice] = useState(null);
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [data, setData] = useState(null);
    const [paymentGateway, setPaymentGateway] = useState("razorpay");
    const [error, setError] = useState(null);




    const location = useLocation();
    const { amount, selected, club_id } = location.state || {};

    const handleAmountPass = async (amount) => {
        setLoading(true);
        setFeedback("");

        try {
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/PartyWittyPay/getDiscountOffer`,
                {
                    amount: amount,
                    club_id: club_id,
                    user_id: userData.id,
                }
            );
            if (response.data.status) {
                setFeedback(`Discount Offer: ${response.data.message || "Success!"}`);
                setData(response.data.data[0]);
            } else {
                setFeedback(`Failed: ${response.data.message}`);
            }
        } catch (error) {
            setFeedback("Error fetching discount offer.");
        }
        setLoading(false);
    };

    useEffect(() => {
        if (amount) {
            handleAmountPass(amount);
        }
    }, [amount]);



    const handleCheckout = async () => {

        if (!data?.order_id) {
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/master/APIs/PartyWittyPay/checkout`,
                {
                    order_id: data?.order_id,
                    user_id: userData?.id,
                    payment_type: "razorpay"
                }
            )

            console.log("order", response.data.order);
            if (response.data.status) {
                if (paymentGateway === "razorpay" && response.data.order) {
                    initializeRazorpay(response.data.order);
                } else if (response.data.redirectUrl) {
                    window.location.href = response.data.redirectUrl;
                } else {
                    setError("Invalid payment data received for Razorpay.");
                }
            } else {
                setError(response.data.msg || "Payment initiation failed");
            }

        } catch (error) {
            console.error("Error:", error);
        }
    };

    // ✅ Razorpay init
    const initializeRazorpay = (paymentData) => {
        if (!window.Razorpay) {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => openRazorpay(paymentData);
            script.onerror = () =>
                setError("Failed to load Razorpay. Please try again.");
            document.body.appendChild(script);
        } else {
            openRazorpay(paymentData);
        }
    };

    const openRazorpay = (paymentData) => {
        console.log("paymentdata", paymentData);

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            amount: paymentData.amount * 100,
            currency: "INR",
            name: "PartyWitty",
            description: `PartyWitty pay - Order ${data?.order_id}`,
            order_id: paymentData.rzp_order_id,
            prefill: {
                name: userData.name || "",
                email: userData.email || "",
                contact: paymentData.userMobile || userData.mobile || "",
            },
            theme: {
                color: "#FF6B6B",
            },
            modal: {
                ondismiss: () => {
                    setProcessing(false);
                    setError("Payment cancelled by user");
                },
            },
            handler: async function (response) {
                try {
                    const verified = await verifyRazorpayPayment(response);
                    if (verified) {
                        navigate(`/partywitty-pay/thank-you`, {
                            state: {
                                orderId: data?.order_id,
                                transactionId: response.razorpay_payment_id,
                                razorpayOrderId: response.razorpay_order_id,
                                signature: response.razorpay_signature,
                            },
                        });
                    } else {
                        setError("Payment verification failed. Please contact support.");
                    }
                } catch (error) {
                    console.error("Payment verification error:", error);
                    setError("Something went wrong during payment verification.");
                }
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", (response) => {
            console.error("Razorpay payment failed:", response);
            setError(`Payment failed: ${response.error.description}`);
            setProcessing(false);
        });

        rzp.open();
    };

    // ✅ Verify Razorpay
    const verifyRazorpayPayment = useCallback(
        async (razorpayResponse) => {
            try {
                const formdata = new FormData();
                formdata.append("response", JSON.stringify(razorpayResponse));

                const url = `${API_BASE_URL}/master/APIs/PartyWittyPay/verifyRzpPaymentPP`


                const response = await axios.post(url, formdata);
                const verificationResponse = response.data;

                if (verificationResponse.status) {
                    iziToast.success({
                        title: "Success",
                        message: verificationResponse.msg,
                        timeout: 5000,
                        position: "topCenter",
                    });
                    return true;
                } else {
                    iziToast.error({
                        title: "Error",
                        message: verificationResponse.msg,
                        timeout: 5000,
                        position: "topCenter",
                    });
                    return false;
                }
            } catch (error) {
                console.error("Error verifying payment:", error);
                iziToast.error({
                    title: "Error",
                    message: "An error occurred while verifying the payment.",
                    timeout: 5000,
                    position: "topCenter",
                });
                return false;
            }
        },
        []
    );

    if (loading || !data) {
        return (
            <div className="partywittycheckout-loading">
                <div className="partywittycheckout-spinner"></div>
                <p>Creating your order...</p>
            </div>
        );
    }





    return (
        <div className="partywitty-pay-container">


            <div className="partywitty-pay-top-bar">
                <button><HiOutlineArrowNarrowLeft onClick={() => navigate(-1)} />Back</button>

                <span className="partywitty-pay-com-logo"><img src={logo} alt="" /></span>

            </div>
            <div className="partywittycheckout-container">
                {/* Savings Banner */}
                <div className="partywittycheckout-banner">
                    Congratulations, You Are Saving ₹{data?.discounted_amount} On This Bill
                </div>

                {/* PartyWitty Pay Offer */}
                <div className="partywittycheckout-pay-offer">
                    Pay using PartyWitty Pay and earn {data?.cashback_amount} Carrots instantly! ✨🎉
                    <span className="partywittycheckout-bonus-text">Bonus with PartyWitty Pay</span>
                </div>

                {/* Discounts Section */}
                <div className="partywittycheckout-discounts">
                    {selected === "food" && (
                        <div className="partywittycheckout-discount-card">
                            <div className="partywittycheckout-discount--wrapper">
                                <span className="partywittycheckout-discount-old">₹{data?.total_amount}</span>
                                <span className="partywittycheckout-discount-new">₹{data?.payable_amount}</span>
                            </div>
                            <div className="partywittycheckout-discount-info">
                                F&B
                                <span className="partywittycheckout-discount-new">
                                    <FaUtensils />  {Number(data?.discounted_amount) / Number(data?.total_amount) * 100}% OFF
                                </span>
                            </div>
                        </div>
                    )}
                    {selected === "alcohol" && (
                        <div className="partywittycheckout-discount-card">
                            <div className="partywittycheckout-discount--wrapper">
                                <span className="partywittycheckout-discount-old">₹{data?.total_amount}</span>
                                <span className="partywittycheckout-discount-new">₹{data?.payable_amount}</span>
                            </div>
                            <div className="partywittycheckout-discount-info">
                                Alcohol
                                <span className="partywittycheckout-discount-new">
                                    <FaGlassMartiniAlt /> 40% OFF
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                {/* Final Bill */}
                <div className="partywittycheckout-final">
                    <div className="partywittycheckout-final-amounts-wrapper">
                        <div className="partywittycheckout-final-icon">
                            <FaRegMoneyBillAlt />
                        </div>
                        <div className="partywittycheckout-final-amounts">
                            <span className="partywittycheckout-final-old">₹{data?.total_amount}</span>
                            <span className="partywittycheckout-final-new">₹{data?.payable_amount}</span>
                        </div>
                    </div>
                    <p className="partywittycheckout-final-text">
                        Here’s your final bill with applied discounts. Enjoy your savings!
                    </p>
                </div>

                {/* Reward Applied */}
                {/* <div className="partywittycheckout-reward">
                    <div className="partywittycheckout-reward-info-wrapper">
                        <span className="partywittycheckout-reward-info">
                            <input type="checkbox" checked readOnly /> You have saved  ₹200 with  <span className="partywittycheckout-reward-code"> TEASERREWARD20 </span>
                        </span>
                        <span className="partywittycheckout-reward-link">View All Rewards <FaArrowRightLong /></span>
                    </div>
                    <button className="partywittycheckout-reward-remove">Remove</button>
                </div> */}

                {/* Bill Details */}
                <div className="partywittycheckout-bill">
                    <h4>Bill Details</h4>
                    <div className="partywittycheckout-bill-row">
                        <span>Payable amount</span>
                        <span>₹{data?.total_amount}</span>
                    </div>
                    {data?.prebooking_amount > 0 && (
                        <div className="partywittycheckout-bill-row">
                            <span>Prebooking Amount</span>
                            <span className="partywittycheckout-green-text">₹300</span>
                        </div>
                    )}
                    <div className="partywittycheckout-bill-row  partywittycheckout-green-text">
                        <span>Reward Discount</span>
                        <span className="partywittycheckout-green-text">-₹{data?.discounted_amount}</span>
                    </div>
                    <div className="partywittycheckout-bill-row partywittycheckout-total">
                        <span>Grand Total</span>
                        <span>₹{data?.payable_amount}</span>
                    </div>
                    <div className="partywittycheckout-bill-row partywittycheckout-small-text">
                        <span>Platform & Other Charges</span>
                        <span>₹5.90</span>
                    </div>
                    <div className="partywittycheckout-bill-row partywittycheckout-final-amount">
                        <span>Payable Amount</span>
                        <span>₹{data?.net_payable_amount}</span>
                    </div>
                </div>
            </div>
            <div className="partywitty-pay-footer">
                <button className="partywitty-pay-proceed-btn" onClick={() => handleCheckout()}>Pay Now ₹{data?.net_payable_amount}</button>
            </div>
        </div>
    );
};

export default PartywittyCheckout;
